import PmcBridge from 'shared/services/pmc-bridge'

export default class PushMagazine {
	private pushMagazine: HTMLElement | null
	private subscribeCta: HTMLElement | null | undefined
	private PMCBridge: PmcBridge
	private isUserSubscribed: boolean

	constructor() {
		this.pushMagazine = document.querySelector('.pushMagazine')
		this.subscribeCta = this.pushMagazine?.querySelector('[data-subscribe-cta]')
		this.PMCBridge = new PmcBridge()
		this.isUserSubscribed = false
	}

	async init() {
		if (!this.subscribeCta) return

		this.isUserSubscribed = await this.PMCBridge.hasSubscription()
		if (this.isUserSubscribed) {
			this.hideSubscribeCta()
		}
	}

	private hideSubscribeCta() {
		this.subscribeCta?.setAttribute('hidden', '')
	}
}
